import { z } from 'zod';

export const BrandWiseMTOPendencySchema = z.array(
  z.object({
    brand_name: z.string(),
    total_brand_wip: z.number(),
    ontime_orders: z.number(),
    delayed_orders: z.number(),
    unknown_vendor_date: z.number(),
    pct_delayed: z.number(),
    items_grned_last_2w: z.number(),
    vendor_id: z.number(),
    poc: z.string(),
  }),
);

export type BrandWiseMTOPendencyResponse = z.infer<typeof BrandWiseMTOPendencySchema>;

const nullableString = z.string().nullable();
const metabaseNumber = z.preprocess(value => {
  if (value === null || value === '') return 0;
  if (typeof value === 'string' && value.trim() !== '') return Number(value);
  return value;
}, z.number());
const nullableMetabaseNumber = z.preprocess(value => {
  if (value === '') return null;
  if (typeof value === 'string' && value.trim() !== '') return Number(value);
  return value;
}, z.number().nullable());

export const MTOHomepageOneViewRowSchema = z.object({
  section: z.enum(['MTO/MTC/JIT_B2B_VENDOR_MANAGED', 'JIT_B2B2C']),
  grain: z.enum(['OVERALL', 'BRAND']),
  brand_name: z.string(),
  vendor_id: nullableMetabaseNumber,
  vendor_name: nullableString,
  brand_poc: nullableString,
  brand_manager: nullableString,
  merch_portfolio: nullableString,
  snapshot_date: z.string().nullable(),
  has_mto_vendor_managed_scope: metabaseNumber,
  has_jit_b2b2c_scope: metabaseNumber,
  total_orders: metabaseNumber,
  live_orders: metabaseNumber,
  pending_acceptance_orders: metabaseNumber,
  pending_for_update_orders: metabaseNumber,
  on_track_orders: metabaseNumber,
  marked_delayed_orders: metabaseNumber,
  penalty_warning_orders: metabaseNumber,
  potential_penalty_orders: metabaseNumber,
  potential_penalty_mrp_exposure: metabaseNumber,
  delayed_orders_3d: metabaseNumber,
  extreme_delay_10plus_orders: metabaseNumber,
  avg_delay_days_after_3d_grace: nullableMetabaseNumber,
  qc_failed_orders: metabaseNumber,
  declined_orders: metabaseNumber,
  disabled_after_decline_orders: metabaseNumber,
  cancelled_orders: metabaseNumber,
  unknown_due_date_orders: metabaseNumber,
  jit_b2b_orders_bucketed_as_mto: metabaseNumber,
  switched_to_jit_b2b2c_orders: metabaseNumber,
  exited_jit_b2b2c_orders: metabaseNumber,
  due_scope_orders: metabaseNumber,
  penalty_eligible_orders: metabaseNumber,
  penalty_eligible_amount: metabaseNumber,
  penalty_sent_to_finance_orders: metabaseNumber,
  penalty_sent_to_finance_amount: metabaseNumber,
  penalty_confirmed_applied_orders: metabaseNumber,
  penalty_confirmed_applied_amount: metabaseNumber,
  penalty_waived_orders: metabaseNumber,
  penalty_waived_amount: metabaseNumber,
});

export const MTOHomepageOneViewSchema = z.array(MTOHomepageOneViewRowSchema);

export type MTOHomepageOneViewRow = z.infer<typeof MTOHomepageOneViewRowSchema>;
export type MTOHomepageOneViewResponse = z.infer<typeof MTOHomepageOneViewSchema>;
